import UserService from "./UserService";
import Kichiri from "./KichiriService";

const QboService = {
	/**
	 * Fetches the list of all authenticated QBO companies (realms), fetching each company name from QBO.
	 * @returns {Promise<Object>} The QBO companies response array.
	 */
	async getCompanies() {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboCompanies({}, {}, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Fetches the list of customers for a given QBO company using the realm ID.
	 * @param {Object} params
	 * @param {string} params.realmId - The QBO company realm ID.
	 * @returns {Promise<Object>} The QBO customers response.
	 */
	async getCustomers({ realmId }) {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboCustomers({ realmId }, {}, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Maps a Workflow client to a QBO company.
	 * @param {Object} params
	 * @param {string} params.workflowClientId - The Workflow client ID to map.
	 * @param {string} params.realmId - The QBO company realm ID.
	 * @returns {Promise<Object>} The mapping response.
	 */
	async mapClient({ workflowClientId, realmId }) {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboMapClient({}, { workflowClientId, realmId }, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},
};

export default QboService;
